module.exports = __webpack_public_path__ + "static/coffeetalk2-e6f74061ac9de91311cd8b35157194ce.webp";